export default "__VITE_ASSET__CIgV_bun__ 720w";